import { useEffect, useMemo, useRef, useState } from "react";
import { Select } from "antd";
import debounce from "lodash.debounce";
const RemoteSelect = ({ fetcher, minLength = 1, value, onChange, ...rest }) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);

  // 序号保护：弱网下先发的请求后返回时，丢弃过期结果
  const seq = useRef(0);
  const search = useMemo(
    () =>
      debounce(async (keyword) => {
        const id = ++seq.current; // 先取号：关键词被删短时，在途的旧请求也随之作废
        const text = keyword?.trim();
        if (!text || text.length < minLength) return setOptions([]);
        try {
          const next = await fetcher(text);
          if (id === seq.current) setOptions(next);
        } catch {
          if (id === seq.current) setOptions([]);
        }
      }, 300),
    [fetcher, minLength],
  );
  useEffect(() => () => search.cancel(), [search]);

  // 值被清空（含 resetFields）时，丢掉保留的已选项
  useEffect(() => {
    if (!value) setSelected(null);
  }, [value]);

  // 搜索结果刷新后，已选项仍保留在选项里，避免标签变成裸 _id
  const merged = useMemo(
    () =>
      selected && !options.some((o) => o.value === selected.value)
        ? [selected, ...options]
        : options,
    [options, selected],
  );

  return (
    <Select
      showSearch
      allowClear
      filterOption={false}
      value={value}
      options={merged}
      onSearch={search}
      onChange={(v, option) => {
        setSelected(v ? option : null);
        onChange?.(v, option);
      }}
      {...rest}
    />
  );
};
export default RemoteSelect;
